<div class="row_1" style="margin-top: 18px !important;">

  <div class="top_grid_agg">
    <app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
    </app-notification-message>

    <div class="grid-agg">
      <div class="upload_file">
        <div class="dropareaZone" style="padding-top:15px">
          <div style="overflow: hidden ;padding-top: 5px ;margin-bottom: 20px;">
            <button class="primarybutton" style="float: right;margin-right:18px" (click)="onBtExport()">
              EXPORT
            </button>

            <button class="primarybutton" style="float: right; margin-right: 20px" (click)="runReportTemplate()">
              DAILY CUBEOUT REPORT
            </button>

            <button class="primarybutton" style="float: right; margin-right: 20px" (click)="addTemplate()">
              ADD
            </button>

            <button class="primarybutton" style="float: right; margin-right: 20px" (click)="emptyTemplate()">
              DOWNLOAD TEMPLATE &nbsp;
              <img src="./assets/images/file-download.png" />
            </button>

            <button class="primarybutton" style="float: right; margin-right: 20px" (click)="importValidate()">
              IMPORT
            </button>

            <button class="primarybutton" style="float: right; margin-right: 20px" (click)="refreshData()">
              REFRESH
            </button>
          </div>
        </div>
      </div>

      <div class="grid-agg">
        <ag-grid-angular [ngStyle]="{'height': dynamicHeight + 'px',
            'width':'100%'}" id="LIOS-GRID" class="ag-theme-balham" [theme]="'legacy'"
          (gridReady)="onGridReady($event)" (window:resize)="sizeToFit()" [animateRows]="true" [columnDefs]="columnDefs"
          [rowData]="displayRowData" [gridOptions]="gridOptions" [context]="context" [pagination]="true"
          [paginationPageSize]="paginationPageSize" [icons]="icons">
        </ag-grid-angular>
        <div class="custom-pagination" *ngIf="totalRecords > 0">
          <div class="left">
            <span class="records-per-page">
              <span>Records/Page : </span>
              <select [(ngModel)]="rpPage" (change)="rppChanged($event)">
                <option *ngFor="let size of pgDropDown" [value]="size.value">{{ size.value }}</option>
              </select>
            </span>
          </div>
          <div class="right">
            <span class="viewing-records">
              <span class="w-600">{{sRecord}}</span> to <span class="w-600">{{eRecord}}</span> of <span
                class="w-600">{{totalRecords}}</span>
              <button (click)="goToFirstPage()" [disabled]="getCurrentPage() === true"><i
                  class="fa-solid fa-backward-fast"
                  [ngStyle]="getCurrentPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
              <button (click)="goToPreviousPage()" [disabled]="getCurrentPage() === true"><i
                  class="fa-solid fa-backward-step"
                  [ngStyle]="getCurrentPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
              <span>Page <span class="w-600">{{cPage}}</span> of <span class="w-600">{{tPage}}</span></span>
              <button (click)="goToNextPage()" [disabled]="isLastPage() === true"><i class="fa-solid fa-forward-step"
                  [ngStyle]="isLastPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
              <button (click)="goToLastPage()" [disabled]="isLastPage() === true"><i class="fa-solid fa-forward-fast"
                  [ngStyle]="isLastPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>